exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-style-history{background:#4d5365!important}.tooltip-style-history .popper__arrow:after{border-top-color:#4d5365!important}", ""]);

// exports
